import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './constants';

/**
 * Fallback chain: arz → ar (MSA strings as backup) → en
 * MSA Arabic is not selectable in the UI.
 */
export function resolveFallbackChain(locale) {
  if (locale === 'arz') return ['ar', DEFAULT_LOCALE];
  if (locale === 'ar') return ['arz', DEFAULT_LOCALE];
  return [DEFAULT_LOCALE];
}

export function normalizeLocale(raw) {
  if (!raw || typeof raw !== 'string') return DEFAULT_LOCALE;
  const lower = raw.toLowerCase().replace('_', '-');
  if (lower === 'ar-eg' || lower === 'arz') return 'arz';
  // Map MSA Arabic (and any other ar-*) to Egyptian Arabic — UI only offers EN + EG.
  if (lower === 'ar' || lower.startsWith('ar-') || lower.startsWith('ar')) return 'arz';
  if (lower.startsWith('en')) return 'en';
  return SUPPORTED_LOCALES.includes(lower) ? lower : DEFAULT_LOCALE;
}

export function detectInitialLocale() {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;
  const stored = typeof localStorage !== 'undefined'
    ? localStorage.getItem('flea_locale')
    : null;
  if (stored) return normalizeLocale(stored);

  const langs = navigator.languages || [navigator.language || ''];
  for (const lang of langs) {
    const normalized = normalizeLocale(lang);
    if (normalized) return normalized;
  }
  return DEFAULT_LOCALE;
}
